<button
  mat-icon-button
  matTooltip="{{ grouped() ? 'Ungroup Treatments' : 'Group Treatments' }}"
  [ngClass]="[colour()]"
  [class.compact]="compact()"
  (click)="toggleTreatmentGrouping()"
>
  <mat-icon>{{ grouped() ? 'grid_off' : 'grid_on' }}</mat-icon>
</button>
